import { TextField } from '@material-ui/core'
import clsx from 'clsx'
import { useStyles } from './style'

export function InputFieldText({
  name,
  type,
  label,
  description,
  disableUnderline,
  className,
  InputProps,
  ...rest
}) {
  const classes = useStyles()
  const isDateOrTime = type === 'date' || type === 'time'
  return (
    <div className={classes.root}>
      {label && (
        <label htmlFor={name} className={classes.inputLabel}>
          {label}
        </label>
      )}
      <TextField
        id={name}
        name={name}
        type={type}
        variant="outlined"
        {...rest}
        className={clsx(classes.inputField, isDateOrTime && classes.dateField)}
        InputProps={{
          ...InputProps
          // disableUnderline: disableUnderline
        }}
        InputLabelProps={{
          ...(isDateOrTime && { shrink: true }),
          ...rest.InputLabelProps
        }}
      />
      {description && <p className={classes.inputDescription}>{description}</p>}
    </div>
  )
}
